import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsComponent } from './documents.component';
import { DocumentsListComponent } from './components/documents-list/documents-list.component';
import { MaterialModule } from '../../material/material.module';


@NgModule({
  declarations: [DocumentsComponent, DocumentsListComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})
export class DocumentsModule { }
